import { useDialog } from 'muibox';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import { handleHttpError } from '../utils/common';
import useAxios from './useAxios';

interface OnlyFansSubscribersCountResponse {
    count: number;
}

const useSubscriberStatsNewSubscribersCount = (
    subscriberId: string | undefined,
    startDate: Date,
    endDate: Date,
    type: 'all' | 'new' | 'renew',
) => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const dialog = useDialog();
    const axios = useAxios();

    const fetchCount = async (): Promise<number> => {
        if (!userContext.jwtToken || !settingsContext.apiKey || !subscriberId || !startDate || !endDate) {
            return 0;
        }

        const query = `${
            settingsContext.routes.onlyFans.base
        }${subscriberId}/stats/subscriptions/subscribers/${type}/count?${new URLSearchParams({
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString(),
        })}`;

        const data = await axios
            .get(query)
            .then(response => response.data as OnlyFansSubscribersCountResponse)
            .catch(error => {
                handleHttpError(error, dialog);

                return null;
            });

        const numeric = Number(data?.count ?? 0);

        return Number.isFinite(numeric) ? numeric : 0;
    };

    return useQuery(['subscriberStatsNewSubscribersCount', subscriberId, startDate, endDate, type], fetchCount, {
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 5, // 5 minutes
        enabled: !!(userContext.jwtToken && settingsContext.apiKey && subscriberId && startDate && endDate),
    });
};

export default useSubscriberStatsNewSubscribersCount;
